import { IUseFetchOptionsParams } from '@common/api.models';
import { DEFAULT_OPTION_ID_FIELD_NAME, FETCH_QUERIES_NAME } from '@common/constants';
import { createUseFetchOptionsFn } from '@common/selectOptions.services';
import { getAllTwcGeRequestProposedAsOptionsAsync } from './projectTwcGeRequestProposedAs.service';

export const useFetchAllTwcGeRequestProposedAsOptions = ({
  isDirty = false,
  shouldConvertOptions = true,
}: IUseFetchOptionsParams) =>
  createUseFetchOptionsFn({
    queryName: FETCH_QUERIES_NAME.PROJECT_TWC_GE_REQUEST_PROPOSED_AS_OPTIONS,
    getOptionsFn: getAllTwcGeRequestProposedAsOptionsAsync,
    enabled: !isDirty,
    handleOptionsProps: {
      idFieldName: DEFAULT_OPTION_ID_FIELD_NAME,
      textFieldName: 'optionTag',
      shouldConvertOptions,
    },
  });
